import react, { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import UnstyledInputBasic from "../UnStyleInputBasic";

const StyledTableHeadGreen = styled(TableCell)(({ theme }) => ({
  // [`&.${tableCellClasses.head}`]: {
  //   backgroundColor: "rgba(6, 98, 59, 1)",
  //   padding:10,
  //   color: theme.palette.common.white,

  // },
  [`&.${tableCellClasses.body}`]: {
    backgroundColor: "rgba(6, 98, 59, 1)",
    fontSize: 15,
    textAlign: "center",
    color: theme.palette.common.white,
    // border: "0px solid rgba(125, 125, 125, 1)",
  },
}));

const StyledTableHeadBlack = styled(TableCell)(({ theme }) => ({
  // [`&.${tableCellClasses.head}`]: {
  //   backgroundColor: "rgba(0, 0, 0, 1)",
  //   padding: 10,
  //   color: theme.palette.common.white,
  //   border: "0px solid rgba(125, 125, 125, 1)",
  //   width: "80px !important",
  //   height: "36px",
  // },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 15,
    backgroundColor: "rgba(0, 0, 0, 1)",
    color: theme.palette.common.white,
    textAlign: "center",
    border: "1px solid rgba(0, 0, 0, 1)",
    // height: "36px",
  },
}));

const StyledPointCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    padding: 0,
    backgroundColor: theme.palette.common.white,
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 1,
    border: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
const borderStyle = { border: 1 };

const RankHead = () => (
  <StyledTableHeadGreen colSpan={4} component="th">
    Rank
  </StyledTableHeadGreen>
);

const PointHead = () => (
  <StyledTableHeadBlack colSpan={4} component="th">
    Points
  </StyledTableHeadBlack>
);
const PointCell = (props) => (
  <StyledPointCell>
    {props.editable ? (
      <UnstyledInputBasic
        name={props.name}
        onChange={props.onChange}
        value={props.value}
      />
    ) : (
      props.value
    )}
  </StyledPointCell>
);

export { RankHead, PointHead, PointCell, UnstyledInputBasic };
